import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';

import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';
import ApplicationId from '../../components/ApplicationId';
import Header from '../../components/Header';
import { useConfig } from '../../config/ConfigContext';
import imgPending from '../../assets/images/pending.svg';
import {
  newCheckInAction,
  NEW_CHECKIN,
} from '../../actions/navigation';

const LuwaPending = (props) => {
  const config = useConfig();
  const { navigate } = props;
  const dispatch = useDispatch();
  const match = useParams();
  const fetch = useSelector((state) => state.fetch);
  const checkinData = useSelector((state) => state.screen.checkinData);

  useEffect(() => {
    const params = parseUrlParams(window.location.search);
    if (isEmpty(checkinData)) {
      const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
      dispatch(newCheckInAction({
        workflowType,
        key: params.key,
      }));
    }
  }, []);

  useEffect(() => {
    if (
      !get(checkinData, 'data.data.returnUrl', get(checkinData, 'state.data.returnUrl'))
      && fetch.isDone[NEW_CHECKIN]
      && !fetch.isRunning[NEW_CHECKIN]
    ) {
      const params = parseUrlParams(window.location.search);
      let routeUrl = get(checkinData, 'data.url').replace(config.hostUrl, '');
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, [checkinData]);

  return (
    <div className="transition-item wrapper v-center">
      <Header navigate={navigate} />
      {get(checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10, marginBottom: -20 }} />
      ) : null}
      <div className="content" style={{ minHeight: 'calc(100vh - 180px)' }}>
        <img src={imgPending} alt="" />
        <h1>APPLICATION PENDING</h1>
        <p>
          You are pre-approved, but we need a bit more information before we can move forward.
        </p>
        <p>
          Please call our
          <br />
          Verification Department
          <br />
          at
          {' '}
          <a href="tel:+18182000238">(818) 200-0238</a>
          .
        </p>
        <div
          style={{
            borderTop: '1px solid rgba(0, 0, 0, .1)',
            borderBottom: '1px solid rgba(0, 0, 0, .1)',
            width: '100%',
            marginTop: 20,
            paddingTop: 10,
            paddingBottom: 20,
          }}
        >
          <p>We are open:</p>
          <p>
            Monday - Friday: 7:00 AM - 8:00 PM Pacific
            <br />
            Saturday & Sunday: 8:00 AM - 8:00 PM Pacific
          </p>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <a href="tel:+18182000238" className="btn">Contact Us</a>
          </div>
        </div>
      </div>
    </div>
  );
};

LuwaPending.propTypes = {
  navigate: PropTypes.func.isRequired,
};

export default LuwaPending;
